export default "__VITE_ASSET__Canuq7Yl__"